import { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { getSelectedServiceId } from '@mews-commander/legacy-entities/src/ducks/serviceSelect';
import DashboardTitle from '../components/DashboardTitle';
import { resetOrderStatistics, startOrderStatisticsPoller } from '../actions/orderStatistics';
import OrderStatisticsChart from './OrderStatisticsChart';

const OrderStatistics = ({ startPoller, resetWidget, selectedServiceId }: $TSFixMe) => {
    useEffect(() => {
        startPoller(selectedServiceId);
        return resetWidget;
    }, [startPoller, resetWidget, selectedServiceId]);
    return (
        <Fragment>
            <DashboardTitle textKey={TextKey.ServiceOrderPlural} />
            <OrderStatisticsChart dataTestId={DataTestId.OrderStatisticsChart} />
        </Fragment>
    );
};

export default connect(
    createStructuredSelector({
        selectedServiceId: getSelectedServiceId,
    }),
    {
        startPoller: startOrderStatisticsPoller,
        resetWidget: resetOrderStatistics,
    }
)(OrderStatistics);
